import styled from '@emotion/styled';
import { RemoveTrashIcon } from 'src/assets/icons/RemoveTrashIcon';
import { DragAndDropIcon } from 'src/assets/icons/DragAndDropIcon';
import { mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';
import { Label } from 'src/domains/layouts/shared/typography/Content.style';
import { ErrorMessage } from 'src/domains/layouts/shared/formComponents/FormComponents.style';
import { Button } from 'src/domains/layouts/shared/buttons/Button';

export const FiltersListWrapper = styled('div', { label: 'FiltersListWrapper' })`
    width: 50%;
    margin-right: 16px;
`;

export const AddCompetitionWrapper = styled(FiltersListWrapper, { label: 'AddCompetitionWrapper' })`
    width: 50%;
    margin-right: 0;
`;

export const SportsFiltersWrapper = styled('div', { label: 'SportsFiltersWrapper' })`
    display: flex;
    flex-flow: row nowrap;
    background-color: ${mainColors.grays.gray100};
    padding: 16px 8px;
    margin: 16px 0 24px 0;
`;

export const FiltersWrapper = styled('div', { label: 'FiltersWrapper' })`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
`;

export const MovableItemWrapper = styled('div', { label: 'MovableItemWrapper' })`
    outline: none;
    margin-top: 4px;
    :first-of-type {
        margin-top: 0;
    }
`;

export const FilterLabelWrapper = styled('div', { label: 'FilterLabelWrapper' })<{isActive: boolean}>`
    display: flex;
    justify-content: space-between;
    height: 32px;
    padding: 8px;
    align-items: center;
    background: ${mainColors.default.light};
    opacity: ${({ isActive }): string => isActive ? '1' : '0.4'};
    border-bottom: 1px solid ${mainColors.grays.gray200};
    cursor: pointer;

    &:last-of-type {
        border-bottom: none;
    }
`;

export const FilterLabel = styled('div', { label: 'FilterLabel' })`
    font-family: var(--fontFamilyPrimary);
    font-size: ${fontSize.xRegular};
    line-height: 1.4;
    font-weight: ${fontWeight.medium};
`;

export const ActionButtonsWrapper = styled('div', { label: 'ActionButtonsWrapper' })`
    display: flex;
`;

export const MovableHandleWrapper = styled('span', { label: 'MovableHandleWrapper' })`
    height: 16px;
    margin-right: 8px;
`;

export const TrashIconWrapper = styled(RemoveTrashIcon, { label: 'TrashIconWrapper' })`
    cursor: pointer;
    width: 16px;
    flex: 0 0 16px;
    align-self: center;
`;

export const DragAndDropIconWrapper = styled(DragAndDropIcon, { label: 'DragAndDropIconWrapper' })<{isDragged: boolean}>`
    width: 18px;
    align-self: center;
    cursor: ${({ isDragged }): string => isDragged ? 'grabbing' : 'grab'};
`;

export const AddCompetitionRow = styled('div', { label: 'AddCompetitionRow' })`
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

export const AddCompetitionButtonWrapper = styled(Button, { label: 'AddCompetitionButtonWrapper' })`
    margin-left: 8px;
`;

export const CompetitionLabel = styled(Label, { label: 'CompetitionLabel' })`
    min-height: 36px;
    padding: 8px;
    background: ${mainColors.default.light};
`;

export const CompetitionError = styled(ErrorMessage, { label: 'CompetitionError' })`
    margin: -16px 0 8px 0;
`;

export const AddedCompetitionWrapper = styled('div', { label: 'AddedCompetitionWrapper' })`
    display: flex;
    background-color: ${mainColors.default.light};
    padding: 8px;
    align-items: center;
    border-bottom: 1px solid ${mainColors.grays.gray200};

    &:last-of-type {
        border-bottom: none;
    }
`;

export const AddedCompetitionLabel = styled(CompetitionLabel, { label: 'AddedCompetitionLabel' })`
    width: 100%;
    height: auto;
    margin-right: 8px;
    padding: 8px 0;
`;

export const AddedCompetitionId = styled(CompetitionLabel, { label: 'AddedCompetitionId' })`
    width: 100px;
    min-height: unset;
    background: ${mainColors.grays.gray200};
    margin-right: 8px;
    padding: 2px;
    white-space: nowrap;
`;
